import ResultsCount from "components/components/ResultsCount/ResultsCount";
import SortableTable, {
  TableCellRender,
} from "components/components/SortableTable/SortableTable";
import { NoWrapCell } from "components/components/SortableTable/style";
import { RestorationZoneDemandForecastTableModel } from "models/restorationZone/restorationZoneDemandForecast";
import React from "react";
import { DateFormat, formatDateTimeString } from "utils/dateHelpers";

interface Props {
  data?: RestorationZoneDemandForecastTableModel[];
}

const RestorationZoneDemandForecastTable: React.FC<Props> = ({ data }) => (
  <>
    <ResultsCount count={data ? data.length : 0} />
    <SortableTable
      headers={{
        submissionDateTime: "Submission Date Time (UTC)",
        settlementDate: "Settlement Date",
        region: "Region",
        gspGroupId: "GSP Group ID",
        forecastDemand60: "60% of Peak Forecast Demand (MW)",
        forecastDemand100: "100% of Peak Forecast Demand (MW)",
      }}
      items={data ?? []}
      renderFns={{
        settlementDate: (el): TableCellRender => ({
          content: (
            <NoWrapCell>
              {formatDateTimeString(el.settlementDate, DateFormat.DateOnly)}
            </NoWrapCell>
          ),
        }),
        submissionDateTime: (el): TableCellRender => ({
          content: (
            <NoWrapCell>
              {formatDateTimeString(el.submissionDateTime, DateFormat.DateTime)}
            </NoWrapCell>
          ),
        }),
      }}
      dataTestId="restoration-zone-demand-forecast-table"
      scrollable={false}
    />
  </>
);

export default RestorationZoneDemandForecastTable;
